var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgProfile = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1875 -1279)"
}, /*#__PURE__*/React.createElement("rect", {
  opacity: 0,
  width: 24,
  height: 24,
  transform: "translate(1899 1279) rotate(90)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#8798ad",
  d: "M561.5,174a2,2,0,1,1-2,2,2,2,0,0,1,2-2m0-2a4,4,0,1,0,4,4,4,4,0,0,0-4-4Zm5.5,15v-3a3,3,0,0,0-3-3h-5a3,3,0,0,0-3,3v3a1,1,0,0,0,2,0v-3a1,1,0,0,1,1-1h5a1,1,0,0,1,1,1v3a1,1,0,0,0,2,0Z",
  transform: "translate(1325.5 1111)"
}))));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgProfile, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/profile.04fee389.svg";
export { ForwardRef as ReactComponent };